import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { StoreService } from '@boxx/store-core/lib/services/store.service';
import { IonSearchbar, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';

@Component({
  selector: 'app-pixabay-select',
  templateUrl: './pixabay-select.component.html',
  styleUrls: ['./pixabay-select.component.scss'],
})
export class PixabaySelectComponent implements OnInit {
  @ViewChild('contactsSB', { static: false }) searchBar: IonSearchbar;
  @Input() maxImages: number;

  arrayImages: any[];
  showSearchBar = false;
  searchValue = '';
  searchResults: any [];
  isLoading = false;
  hasMoreResult = false;
  translations: any;
  page: number;
  totalPage: number;
  destroyed$ = new Subject<boolean>();
  
  constructor(private modalCtrl: ModalController,
    private service: StoreService,
    private translateService: TranslateService,
    private boxxUtils: BoxxUtilsService,
    ) {
      this.translateService
      .get(['BUSINESS_FORMS', 'IMAGES_MODULE'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t) => (this.translations = t));

    }

  ngOnInit() {
    this.page = 1;
    this.searchResults = [];
    this.arrayImages = [];
  }

  selectImage(itemImage: any) {
    if(this.arrayImages.length < this.maxImages){
      this.arrayImages.push(itemImage);
      if(this.arrayImages.length === this.maxImages){
        this.selectImages();
      }
    }
    else{    
      this.boxxUtils.showToastError({
        message: this.translations.IMAGES_MODULE.CROP_MODAL.max_images,
      });  
    }
  }

  selectImages(){
    this.modalCtrl.dismiss({ pixabayImages: this.arrayImages });
  }

  removeImage(index){
    this.arrayImages.splice(index, 1); 
  }

  close(){
    this.modalCtrl.dismiss();
  }

  async search(search: string) {
    
    if (!search) {
      return;
    }

    this.isLoading = true;
    const dataParams = {
      query: search,
      page: this.page
    }
    this.hasMoreResult = false;
    this.searchResults = [];
    const dataSearch = await this.service.searchImages(dataParams)
    .toPromise();
    
    if(dataSearch){    
      this.isLoading = false;
      if(dataSearch.data.meta.total > 0){ //has result
        this.page = 1;
        this.totalPage = dataSearch.data.meta.totalPage;
        this.searchResults = dataSearch.data.attributes;
        if(this.totalPage > this.page){
          this.hasMoreResult = true;
        }
      }
      else{
        this.hasMoreResult = false;
        this.boxxUtils.showToastError({
          message: this.translations.BUSINESS_FORMS.WEBPAGE.PIXABAY_PAGE.no_images,
        });
      }
    }
  }

  async loadMore(search: string) {
    if (!search) {
      this.searchResults = [];
      return;
    }

    this.isLoading = true;
    this.hasMoreResult = false;
    const dataParams = {
      query: search,
      page: this.page + 1
    }

    const dataSearch = await this.service.searchImages(dataParams)
    .toPromise();
    
    if(dataSearch){
      this.isLoading = false;
      if(dataSearch.data.meta.total > 0){ //has result
        for(let i = 0; i < dataSearch.data.attributes.length; i++){
          this.searchResults.push(dataSearch.data.attributes[i]);
        }
        if(this.totalPage > this.page){
          this.hasMoreResult = true;
        }
      }
      else{
        this.boxxUtils.showToastError({
          message: this.translations.BUSINESS_FORMS.WEBPAGE.PIXABAY_PAGE.no_images,
        });
      }
    }
  }

  onCancelSearch() {
    //this.showSearchBar = false;
  }


}
